module.exports = __webpack_public_path__ + "img/three-dots.8a1fe1f9.svg";